import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const CancellationRefundPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Header */}
      <section className="py-16 px-6 md:px-12 lg:px-24 border-b bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-semibold text-[#0f3e3e] mb-2">
            Cancellation & Refund Policy
          </h1>
          <p className="text-sm text-muted-foreground mb-4">
            Last Updated: 01 January 2025
          </p>
          <p className="text-muted-foreground">
            This Cancellation and Refund Policy applies to all courses, training
            programs, and services offered by Safety Training Institute through
            our website or offline modes.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto space-y-8 text-muted-foreground leading-relaxed">

          <p>
            By enrolling in any course offered by Safety Training Institute, you
            agree to the terms outlined in this Cancellation & Refund Policy.
          </p>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              1. Course Cancellation by Student
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>
                Cancellation requests must be submitted in writing via email or
                WhatsApp.
              </li>
              <li>
                Once course access, training materials, or classes have started,
                cancellation requests may not be accepted.
              </li>
              <li>
                Administrative charges may apply in eligible cancellation cases.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              2. Refund Policy
            </h2>
            <p>Course fees are generally non-refundable.</p>
            <p className="mt-2">No refund will be provided once:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Course access is activated</li>
              <li>Training sessions have started</li>
              <li>Study materials are shared</li>
              <li>Certificate generation process has begun</li>
            </ul>
            <p className="mt-2">
              Refunds, if approved under special circumstances, will be processed
              within <strong>7–14 working days</strong>.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              3. Non-Refundable Situations
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Failure to attend classes or complete the course</li>
              <li>Incorrect information provided by the student</li>
              <li>Change of mind after enrollment</li>
              <li>Violation of institute rules or misconduct</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              4. Course Cancellation by Institute
            </h2>
            <p>
              Safety Training Institute reserves the right to cancel or reschedule
              any course due to unavoidable circumstances. In such cases:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Students may be offered an alternative batch or schedule, or</li>
              <li>
                A refund may be processed at the discretion of the institute
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              5. Certificate & Verification Policy
            </h2>
            <p>
              Once a certificate is issued or made available for download, no
              cancellation or refund will be entertained.
            </p>
            <p className="mt-2 font-medium">
              Important Note: Admission fees, registration fees, and
              administrative charges are non-refundable under any circumstances.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              6. Payment Refund Method
            </h2>
            <p>
              Approved refunds will be processed using the original payment
              method. Transaction charges, if any, will be deducted.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              7. Changes to This Policy
            </h2>
            <p>
              Safety Training Institute reserves the right to modify this
              Cancellation and Refund Policy at any time without prior notice.
              Updated policies will be posted on this page.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              8. Contact Us
            </h2>
            <p><strong>Institute Name:</strong> Safety Training Institute</p>
            <p><strong>Location:</strong> Bahanaga, Balasore, Odisha – 756042</p>
            <p><strong>Phone:</strong> 8280607556 / 9938232920</p>
            <p>
              <strong>Email:</strong>{" "}
              <a
                href="mailto:info@safetytraininginstitute.org.in"
                className="text-[#0f3e3e] font-medium"
              >
                info@safetytraininginstitute.org.in
              </a>
            </p>
            <p>
              <strong>Website:</strong>{" "}
              <a
                href="https://www.safetytraininginstitute.org.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0f3e3e] font-medium"
              >
                www.safetytraininginstitute.org.in
              </a>
            </p>
          </div>

        </div>
      </section>
      <Footer/>
    </div>
    
  );
};

export default CancellationRefundPolicy;
